var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductCatalogue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000009332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5006 2.80151H13.2507C13.7149 2.80151 14.1601 2.99114 14.4883 3.32868C14.8165 3.66621 15.0009 4.12401 15.0009 4.60136V17.2003C15.0009 17.6776 14.8165 18.1354 14.4883 18.473C14.1601 18.8105 13.7149 19.0001 13.2507 19.0001H2.75011C2.28595 19.0001 1.8408 18.8105 1.51259 18.473C1.18439 18.1354 1 17.6776 1 17.2003V4.60136C1 4.12401 1.18439 3.66621 1.51259 3.32868C1.8408 2.99114 2.28595 2.80151 2.75011 2.80151H4.50021",
    fill: "#68A14B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5006 2.80151H13.2507C13.7149 2.80151 14.1601 2.99114 14.4883 3.32868C14.8165 3.66621 15.0009 4.12401 15.0009 4.60136V17.2003C15.0009 17.6776 14.8165 18.1354 14.4883 18.473C14.1601 18.8105 13.7149 19.0001 13.2507 19.0001H2.75011C2.28595 19.0001 1.8408 18.8105 1.51259 18.473C1.18439 18.1354 1 17.6776 1 17.2003V4.60136C1 4.12401 1.18439 3.66621 1.51259 3.32868C1.8408 2.99114 2.28595 2.80151 2.75011 2.80151H4.50021",
    stroke: "white",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.6254 0.999878H5.37505C4.89177 0.999878 4.5 1.40279 4.5 1.8998V3.69965C4.5 4.19666 4.89177 4.59957 5.37505 4.59957H10.6254C11.1087 4.59957 11.5004 4.19666 11.5004 3.69965V1.8998C11.5004 1.40279 11.1087 0.999878 10.6254 0.999878Z",
    fill: "#68A14B",
    stroke: "white",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCatalogue);
export default __webpack_public_path__ + "static/media/product-catalogue.35f3fa4fc394fc3e17fc2468573861f7.svg";
export { ForwardRef as ReactComponent };